import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/gradebook/:gradebookId?',
        component: () => import('@/pages/courses/gradebook/Gradebook.vue'),
        props: true,

        children: [
            {
                name: 'gradebook-view',
                path: '',
                component: () => import('@/components/gradebook/GradebookView.vue'),
                meta: {
                    title: 'Gradebook',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'gradebook' },
                },
                props: true,
            },
            {
                name: 'gradebook-audit-log',
                path: 'audit-log',
                component: () => import('@/components/gradebook/GradebookView.vue'),
                meta: {
                    title: 'Gradebook Audit Log',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'gradebook' },
                },
                props: true,
            },
            {
                path: 'activities/:activityId/user/:userId/activity-grader/:submissionId',
                component: () => import('@/pages/courses/activity-grader/ActivityGrader.vue'),
                meta: {
                    title: 'Gradebook',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'gradebook' },
                },
                props: true,
                children: [
                    {
                        name: 'gradebook-activity-grader',
                        path: '',
                        component: () => import('@/components/activity-grader/ActivityGraderView.vue'),
                    },
                ],
            },
        ],
    },
];
